module.exports = __webpack_public_path__ + "img/feature2-2.f5d49bd9.png";